import { render, staticRenderFns } from "./SpecialCategory.vue?vue&type=template&id=4dc576d8&scoped=true&"
import script from "./SpecialCategory.vue?vue&type=script&lang=js&"
export * from "./SpecialCategory.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCategory.vue?vue&type=style&index=0&id=4dc576d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc576d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc576d8')) {
      api.createRecord('4dc576d8', component.options)
    } else {
      api.reload('4dc576d8', component.options)
    }
    module.hot.accept("./SpecialCategory.vue?vue&type=template&id=4dc576d8&scoped=true&", function () {
      api.rerender('4dc576d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinisteRegister/SpecialCategory.vue"
export default component.exports